/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { DropdownArrowIcon } from '../../../../../images/icons/DropdownArrow/DropdownArrow'
import OptionsItem from './OptionsItem'
import OptionsCheckbox from './OptionsCheckbox'
import { Alert } from '../../../../common/Alert/Alert'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 *     Step main container
 */
export default class VariationOptions extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            values: this.props.values,
            dirty: false,
            errorList: [],
        }
    }

    handleCheckbox = () => {
        return true
    }

    handleItemChange = (field: string, value: any) => {
        let val = 0
        if (this.props.dirty) {
            this.props.dirty(true)
        }

        if (value) {
            val = value
        }
        this.setState({
            values: { ...this.state.values, [field]: val },
            dirty: true,
        })
    }

    handleSubmit = (event: any) => {
        event.preventDefault()
        let errorList: any = []

        let checkAmount500 = (item: any, value: any) => {
            if (value < 500 && value !== null && value !== 0) {
                errorList.push(item.toString())
            }
        }

        for (var property in this.state.values) {
            if (this.state.values[property] != null) {
                switch (property) {
                    case 'money':
                    case 'glass':
                    case 'cancellationCover':
                    case 'defectiveTitle':
                    case 'unattendedVehicleCover':
                        checkAmount500(property, this.state.values[property])
                        break
                    default:
                        break
                }
            }
        }

        if (errorList.length !== 0) {
            this.setState({ errorList: errorList })
        } else {
            this.props.handleAdjustChangeOptions(this.state.values)
            this.setState({ dirty: false, errorList: [] })
            if (this.props.dirty) {
                this.props.dirty(false)
            }
        }
    }

    render() {
        const { isMTA = false, isRenewal = false } = this.props
        return (
            <div>
                <form
                    onSubmit={this.handleSubmit}
                    className={`${this.props.optionsOpen ? 'open' : null}
                    ${this.state.dirty ? 'plus57' : null}
                    ${(this.state.errorList.length) ? 'plus102' : null} art_step05_options`}
                >
                    <div
                        className={`variation__options__title ${this.props.optionsOpen ? 'open' : null}`}
                        onClick={this.props.toggleOptionsOpen}
                    >
                        <DropdownArrowIcon color={`#F07662`} />
                        <span>{this.props.optionsOpen ? 'Hide' : 'View'} cover options</span>
                        <DropdownArrowIcon color={`#F07662`} />
                    </div>
                    <div
                        className={`variation__options__content options ${!this.props.optionsOpen ? 'closed' : null}`}
                    >
                        {this.state.errorList.length !== 0 &&
                            <Alert
                                type="error"
                                className={`errorMessage ${(this.state.errorList.length) ? 'visible' : ''}`}
                            >
                                <p>
                                    {`Cover options must be greater than ${symbol()} 500`}
                                    :
                                    {this.state.errorList.map((a, i) => (a + ' '))}
                                </p>
                            </Alert>}
                        <OptionsItem
                            id="money"
                            title="Money"
                            checked={false}
                            handleItemChange={this.handleItemChange}
                            value={this.props.values.money}
                            hideTooltip={true}
                        />

                        <OptionsItem
                            id="glass"
                            title="Glass"
                            checked={false}
                            handleItemChange={this.handleItemChange}
                            value={this.props.values.glass}
                            hideTooltip={true}
                        />

                        <OptionsItem
                            id="cancellationCover"
                            title="Cancellation cover for trade fairs"
                            checked={false}
                            handleItemChange={this.handleItemChange}
                            value={this.props.values.cancellationCover}
                        >
                            Sum insured per trade fair
                        </OptionsItem>

                        <OptionsItem
                            id="defectiveTitle"
                            title="Defective title"
                            handleItemChange={this.handleItemChange}
                            checked={false}
                            value={this.props.values.defectiveTitle}
                            retroactiveDate={this.props.values.retroactiveDate}
                            datePickerShow={true}
                            isMTA={isMTA || isRenewal}
                            customCls={'defective_retro_group'}
                        >
                            This is a dispute of ownership cover and protects the insured against any claim which is
                            first made against them and notified to insurers during the period of insurance, arising out
                            of the defective title of stock purchased in the course of the insured’s business.
                        </OptionsItem>

                        {/* <OptionsItem
                            id="personalAccident"
                            title="Personal accident"
                            placeholder="Number of people"
                            handleItemChange={this.handleItemChange}
                            value={this.props.values.personalAccident}
                            checked={false}
                            hideTooltip={true}
                        /> */}

                        <OptionsItem
                            id="unattendedVehicleCover"
                            title="Unattended vehicle cover"
                            handleItemChange={this.handleItemChange}
                            checked={false}
                            value={this.props.values.unattendedVehicleCover}
                        >
                            The maximum any one loss of stock whilst in an unoccupied vehicle. It is a condition
                            precedent for any cover for Insured property left in any unattended vehicle belonging to the
                            Insured that the vehicle is locked, and goods are out of sight, hidden from view. The
                            ignition key must be removed from the vehicle. If left overnight, the vehicle must be
                            garaged or kept in a securepremises or pound.
                        </OptionsItem>

                        <OptionsCheckbox
                            id="terrorism"
                            title="Terrorism"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.terrorism || false}
                            value={this.props.values.terrorism}
                        >
                            {/* Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections. */}
                            If terrorism cover is required please only select this option
                            if the proposer is a commercial entity rather than a private individual.
                        </OptionsCheckbox>

                        <OptionsCheckbox
                            id="shoplifting"
                            title="Shoplifting"
                            checked={this.props.values.shoplifting || false}
                            handleItemChange={this.handleItemChange}
                            value={this.props.values.shoplifting}
                            tooltipVerticalPosition="top"
                        >
                            Select to remove cover for losses following shoplifting
                        </OptionsCheckbox>
                        {/* <OptionsCheckbox
                            id="accidentalDamage"
                            title="Accidental damage"
                            checked={this.props.values.accidentalDamage || false}
                            handleItemChange={this.handleItemChange}
                            value={this.props.values.accidentalDamage}
                        >
                            Select to remove cover for losses following accidental damage to property insured under the
                        Fine Art Stock and Material Damage sections
                        </OptionsCheckbox> */}

                    </div>
                    <button className={`submit ${this.state.dirty ? 'visible' : null}`} type="submit">Update</button>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/VariationOptions.tsx